module.exports = __webpack_public_path__ + "static/media/icon-linkedIn.7809c506.svg";